import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import { includes } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Autocomplete, Select } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeData,
  updateData,
} from '~/store/modules/operacaoTotalizadorVeiculo/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const [totalizador2, setTotalizador2] = useState(0);
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.operacaoTotalizadorVeiculo
  );

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        totalizadorveiculo: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        totalizador2veiculo: Yup.number().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        totalizadorveiculo: param.totalizadorveiculo,
        totalizador2veiculo: param.totalizador2veiculo,
        idcliente: client,
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      setTotalizador2(Number(initials.tipototalizador2veiculo) || 0);
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            disabled
            name="idveiculo"
            label={t('s.cadastro.veiculo.idveiculo')}
          />

          <Autocomplete
            disabled
            name="idempresaveiculo"
            label="nomeempresaveiculo"
            url="empresasveiculos"
            unique="idempresaveiculo"
            title={t('s.cadastro.veiculo.idempresaveiculo')}
          />

          <Input
            disabled
            name="placaveiculo"
            label={t('s.cadastro.veiculo.placaveiculo')}
          />

          <Select
            disabled
            name="tipoveiculo"
            label={t('s.cadastro.veiculo.tipoveiculo')}
            options={[
              { value: 0, label: t('s.cadastro.veiculo.proprio') },
              { value: 1, label: t('s.cadastro.veiculo.terceiros') },
              { value: 2, label: t('s.cadastro.veiculo.comboio') },
            ]}
          />
          <Input
            name="totalizadorveiculo"
            label={t('s.cadastro.veiculo.totalizadorveiculo')}
            type="number"
          />

          <Input
            name="totalizador2veiculo"
            type="number"
            label={t('s.cadastro.veiculo.totalizador2veiculo')}
            style={{
              display: includes([1, 2], totalizador2) ? 'block' : 'none',
            }}
          />

          {/* <Input
            name="totalizador2veiculo"
            label={t('s.cadastro.veiculo.totalizador2veiculo')}
            type="number"
          /> */}
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
